import { useEffect, useCallback } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

/**
 * Visor de foto/video en grande con flechas prev/next y botón de cerrar.
 * Los videos se reproducen con controles y sonido (a diferencia de la miniatura,
 * que va muda en autoplay).
 */
export function Lightbox({ mediaList, index, onClose, onNavigate }) {
  const item = mediaList[index];

  const goPrev = useCallback((e) => {
    e?.stopPropagation();
    onNavigate((index - 1 + mediaList.length) % mediaList.length);
  }, [index, mediaList.length, onNavigate]);

  const goNext = useCallback((e) => {
    e?.stopPropagation();
    onNavigate((index + 1) % mediaList.length);
  }, [index, mediaList.length, onNavigate]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      else if (e.key === "ArrowLeft") goPrev();
      else if (e.key === "ArrowRight") goNext();
    };
    window.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose, goPrev, goNext]);

  if (!item) return null;

  return (
    <div
      className="pp2-lightbox-overlay"
      data-testid="pp2-services-lightbox"
      onClick={onClose}
    >
      <button className="pp2-lightbox-close" onClick={onClose} aria-label="Cerrar" data-testid="pp2-lightbox-close-btn">
        <X size={24} />
      </button>
      {mediaList.length > 1 && (
        <button className="pp2-lightbox-arrow pp2-lightbox-arrow-left" onClick={goPrev} aria-label="Anterior" data-testid="pp2-lightbox-prev-btn">
          <ChevronLeft size={28} />
        </button>
      )}
      <div className="pp2-lightbox-content" onClick={(e) => e.stopPropagation()}>
        {item.tipo === "video" ? (
          <video src={item.url} controls autoPlay playsInline className="pp2-lightbox-media" data-testid="pp2-lightbox-video" />
        ) : (
          <img src={item.url} alt={item.caption || ""} className="pp2-lightbox-media" data-testid="pp2-lightbox-image" />
        )}
        {item.caption && <p className="pp2-lightbox-caption">{item.caption}</p>}
      </div>
      {mediaList.length > 1 && (
        <button className="pp2-lightbox-arrow pp2-lightbox-arrow-right" onClick={goNext} aria-label="Siguiente" data-testid="pp2-lightbox-next-btn">
          <ChevronRight size={28} />
        </button>
      )}
    </div>
  );
}
